module.exports = __webpack_public_path__ + "media/luxury-2026/blue-library-9d5769d7.jpg";